import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  /**
   * Same inset as `CoachOfferingGroupEvents` on the legacy profile:
   * `xs={11}` / `lg={9}` Grid with `margin: 0 auto`. Do not use
   * `coach-offering-group-events` `offeringsRoot` — that class is a
   * full-bleed photos wrapper (`width: 100%; margin: 0`).
   */
  offeringsRoot: {
    margin: '0 auto',
    paddingTop: '3rem',
  },
  offeringsOverline: {
    color: theme.palette.primary.dark,
    fontSize: '12px',
    fontFamily: 'Nunito Sans',
    letterSpacing: '1px',
  },
}))

export default useStyles
